export function validatePassword(
  password?: string,
  required: boolean = true
): string | undefined {
  if (!password) {
    return required ? `Password is required` : undefined;
  }

  if (password.length < 8) {
    return `Password must be at least 8 characters long`;
  }

  return undefined;
}

export function validatePasswordWithConfirm(
  password?: string,
  confirmPassword?: string,
  required: boolean = true
): string | undefined {
  const passwordValidation = validatePassword(password, required);

  if (passwordValidation) {
    return passwordValidation;
  }

  if ((required || password) && password !== confirmPassword) {
    return `Confirmation and password must match`;
  }

  return undefined;
}



// WEBPACK FOOTER //
// ./src/app/validators/password.ts